﻿import { Tooltip, ScrollSpy, Modal } from 'bootstrap';
import Dropzone from 'dropzone';

Object.assign(window, {
    bootstrap: {
        Tooltip,
        Modal,
        ScrollSpy
    },
    Dropzone
});